export const _bmpMimeTypes = [
  "image/bmp",
  'image/bmp; version="1.0"',
  'image/bmp; version="2.0"',
  'image/bmp; version="3.0 nt"',
  'image/bmp; version="3.0"',
  'image/bmp; version="4.0"',
  'image/bmp; version="5.0"',
];
